import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root',
})
export class TariffDataServicesService {
    private baseUrl = environment.apiBaseUrl;
    constructor(private http: HttpClient, private dataService: DataService) {}

    GetProductDetailsById(productId: any,changeofservice=false,applicationid=0) {
        return this.dataService.getRecord(
            '/api/product/GetProductDetailsById/' + productId+'/'+changeofservice+'/'+applicationid
        );
    }

    GetProductById(productId: number) {
        return this.dataService.getRecord(
            '/api/product/GetProductById/' + productId
        );
    }

    GetConnectionFeeDetails(areaProductMappingId: number) {
        return this.dataService.getRecord(
            '/api/product/GetConnectionFeeByAreaProductMappingId/' +
                areaProductMappingId
        );
        //return this.dataService.getRecordWithParams('/api/product/GetConnectionFeeByServiceProviderProductMappingId/' + serviceProviderProductMappingId)
    }
   
    GetProductDetailsByApplicationId(applicationId: number) {
        return this.dataService.getRecord(
            '/api/Application/GetApplicationDetailsByIdFromApplicationView/' +
                applicationId
        );
        //return this.dataService.getRecordWithParams('/api/product/GetConnectionFeeByServiceProviderProductMappingId/' + serviceProviderProductMappingId)
    }
    GetConnectionFeeDetailsByServiceChangeReqId(serviceChangeReqId: number) {
        return this.dataService.getRecord(
            '/api/product/GetConnectionFeeDetailsByServiceChangeReqId/' +
                serviceChangeReqId
        );
        //return this.dataService.getRecordWithParams('/api/product/GetConnectionFeeByServiceProviderProductMappingId/' + serviceProviderProductMappingId)
    }
    GetProductAndConnectionFeebyServiceChangeReqId(
        serviceChangeRequestId: number
    ) {
        return this.dataService.getRecord(
            '/api/Application/GetProductAndConnectionFeebyServiceChangeReqId/' +
                serviceChangeRequestId
        );
    }
    GetProductDetailsByIdFromApplicationView(serviceChangeRequestId: number) {
        return this.dataService.getRecord(
            '/api/ServiceChangeRequest/GetProductDetailsByIdFromApplicationView/' +
                serviceChangeRequestId
        );
        //return this.dataService.getRecordWithParams('/api/product/GetConnectionFeeByServiceProviderProductMappingId/' + serviceProviderProductMappingId)
    }
    GetServiceRequestChange(applicationId: number) {
        return this.dataService.getRecord(
            '/api/ServiceChangeRequest/getServiceRequestChange/' + applicationId
        );
        //return this.dataService.getRecord('/api/activity/getApplicationActivity/?applicationActivityId=' + applicationActivityId);
    }

    GetTerminationCalculationFromCancellation(serviceChangeRequestId: number) {
        return this.dataService.getRecord(
            '/api/ServiceChangeRequest/getTerminationCalculationFromCancellation/' +
                serviceChangeRequestId
        );
    }
    GetCostForProductChange(productId: number) {
        return this.dataService.getRecord(
            '/api/product/GetCostForProductChange/' + productId
        );
    }

    getResellerServiceChangeProductDetail(serviceChangeRequestId: number) {
        return this.dataService.getRecord(
            '/api/Application/getResellerServiceChangeProductDetail/' +
                serviceChangeRequestId
        );
    }
}
